var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 13.8369C18.456 14.5683 19.7042 15.742 20.6153 17.2096C20.7957 17.5003 20.886 17.6456 20.9172 17.8468C20.9805 18.2558 20.7009 18.7585 20.32 18.9204C20.1326 19 19.9218 19 19.5001 19M15.0001 9.53224C16.4818 8.79589 17.5001 7.26686 17.5001 5.5C17.5001 3.73314 16.4818 2.20411 15.0001 1.46776M13.0001 5.5C13.0001 7.98528 10.9854 10 8.50008 10C6.0148 10 4.00008 7.98528 4.00008 5.5C4.00008 3.01472 6.0148 1 8.50008 1C10.9854 1 13.0001 3.01472 13.0001 5.5ZM1.55931 16.9383C3.15362 14.5446 5.66945 13 8.50008 13C11.3307 13 13.8465 14.5446 15.4409 16.9383C15.7901 17.4628 15.9648 17.725 15.9446 18.0599C15.929 18.3207 15.758 18.64 15.5496 18.7976C15.282 19 14.9139 19 14.1777 19H2.82244C2.08625 19 1.71816 19 1.45052 18.7976C1.24213 18.64 1.07117 18.3207 1.05551 18.0599C1.03541 17.725 1.21004 17.4628 1.55931 16.9383Z",
    stroke: "#1943DC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.974cec8c6be0d86097ac0c4a42c7e813.svg";
export { ForwardRef as ReactComponent };